import { IPoint } from '../../@types/IPoint';

export function isPointEqual(a: IPoint, b: IPoint): boolean {
  return Boolean(a && b && a.x === b.x && a.y === b.y);
}
